import React from "react";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { selectSpecificFormSetting } from "../../../redux/slices/formSettingsSlice";

import AccountPage from "./AccountPage";
import { selectRegistrationAccount } from "../../../redux/slices/registrationAccountSlice";

const ConnectedAccountPage = () => {
    const title = useSelector((state) =>
        selectSpecificFormSetting(state, "title"),
    );
    const registrationAccount = useSelector(selectRegistrationAccount);
    const {
        urls: { eventHome },
        form: { initialGlobalAccountAction },
    } = registrationAccount;
    const {
        ENUMS: { GlobalAccountAction },
    } = constants;

    let documentTitle = `${title} | `;

    if (initialGlobalAccountAction === GlobalAccountAction.RESET_PASSWORD) {
        documentTitle += "Reset Your Password";
    } else if (
        initialGlobalAccountAction === GlobalAccountAction.ACTIVATE_ACCOUNT
    ) {
        documentTitle += "Activate Your Account";
    } else {
        documentTitle += "Log In";
    }

    const accountPageProps = {
        eventHome,
        documentTitle,
    };

    return <AccountPage {...accountPageProps} />;
};

export default ConnectedAccountPage;
